/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TagValueTypeFromJSON, TagValueTypeToJSON, } from './TagValueType';
/**
 * Check if a given object implements the TagListEntry interface.
 */
export function instanceOfTagListEntry(value) {
    var isInstance = true;
    isInstance = isInstance && "valueType" in value;
    return isInstance;
}
export function TagListEntryFromJSON(json) {
    return TagListEntryFromJSONTyped(json, false);
}
export function TagListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'valueType': TagValueTypeFromJSON(json['valueType']),
        'predefinedValues': !exists(json, 'predefinedValues') ? undefined : json['predefinedValues']
    };
}
export function TagListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'valueType': TagValueTypeToJSON(value.valueType),
        'predefinedValues': value.predefinedValues
    };
}
